import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { IInsurance } from 'src/app/models/common/insurance';
import { BackendListModel } from 'src/app/models/common/list.model';
import { DomainCode } from 'src/app/models/common/model';
import { TermsAndConditionsModel } from 'src/app/models/common/terms-and-conditions.model';
import { ApiRoutes } from 'src/app/services/apiroutes';
import { AuthService } from 'src/app/services/auth.service';
import { DomainCodeApiService } from 'src/app/services/domain_code/domain-code-api.service';
import { RequestApiService } from 'src/app/services/domain_code/request-api.service';
import { PickupDropoffScheduleLeaseComponent } from '../../pickup-dropoff-schedule-lease/pickup-dropoff-schedule-lease.component';
import { MatDialog } from '@angular/material/dialog';
import { PickupDropoff } from 'src/app/models/pickup-dropoff';
import { LeaseDocuments, LeaseRemarksList } from 'src/app/models/lease-quote';
import { DocumentModel } from 'src/app/models/document';
import { EroAddUpdateComponent } from '../../ero-add-update/ero-add-update.component';
import { RequestDetailModel } from 'src/app/models/request-detail-model';
import { LeaseAgreementTncDocumentsClass } from 'src/app/models/lease-agreement-tnc-documents';
import { InfoContentComponent } from '../../info-content/info-content.component';
import { environment } from 'src/environments/environment';
import { LeaseQuoteItemModel, LeaseQuoteModel, EarlyReturnOptions, PickupSchedule, DropoffSchedule, LeaseQuoteItemError, LeaseAgreementError, LeaseAgreement, PickupScheduleError, DropoffScheduleError } from './lease-quote';
import { BehaviorSubject } from 'rxjs';
import { ContainerSizeType, QuoteChargeMaster, QuoteChargeMasterError, RequestQuotesChargesList } from '../base-quote.model';
import { QuillEditorComponent } from 'ngx-quill';
import { LeaseQuoteTableService } from './lease-quote-table.service';
import { WarningBoxComponent } from 'src/app/components/dialog-box/warning-box/warning-box.component';

@Component({
  selector: 'logzy-lease-quote-table',
  templateUrl: './lease-quote-table.component.html',
  styleUrls: ['./lease-quote-table.component.scss']
})
export class LeaseQuoteTableComponent implements OnInit {

  @Input() negotiate: boolean = true;
  @Input() case: string = '';

  // @Input() baseQuote: LeaseQuoteModel;
  @Input() refreshQuote = new BehaviorSubject(null);
  @Input() oldQuoteList;

  existingQuoteList;

  quoteList: LeaseQuoteItemModel[];

  @Output() edit: EventEmitter<any> = new EventEmitter();
  @Output() editPickup = new EventEmitter();
  @Output() editDropoff = new EventEmitter();

  @Output() review: EventEmitter<any> = new EventEmitter();
  @Output() updateRequest: EventEmitter<any> = new EventEmitter();

  isCustomer: boolean;
  Editing: boolean = true;
  disableSaveButton: boolean = false;
  currentDate = new Date();
  insuranceList: BackendListModel<IInsurance>;
  downloadUrl = ApiRoutes.LeadRequest;
  insuranceUrl = `${ApiRoutes.Insurance}insurance/?search=::search::`
  ralUrl = `${ApiRoutes.ContainerMaster}ral_master/?search=::search::`;
  containerSizeTypeUrl = `${ApiRoutes.ContainerMaster}container_size_type/?search=::search::`
  containerConditionLists = `${ApiRoutes.DomainCode}?group=ContainerCondition`
  location_url = `${ApiRoutes.Location}?location_type_name=port&search=::search::`;
  requestId: string;
  type: string;
  rType: string;

  containerConditionList: BackendListModel<DomainCode>;
  termsConditionList: TermsAndConditionsModel[] = [];
  editInsuranceAmount: boolean = false;
  insuranceLabel: string;
  getDataInsurance: boolean = true;
  insuranceExpand: boolean = true;
  tncExpand: boolean = true;
  pickupScheduleExpand: boolean = false;
  dropoffScheduleExpand: boolean = false;
  uploadDocExpand: boolean = false;
  remarkExpand: boolean = true;
  isQuotation: boolean = true;
  reviewQuotation;
  isEditable: boolean = false;
  reviewquote: boolean = false;
  errorObj: any = {};
  earlyReturnOption: EarlyReturnOptions[] = [];

  scheduleListP: PickupSchedule[] = [];
  scheduleListD: DropoffSchedule[] = [];
  scheduleListPickup: PickupDropoff[] = [];
  scheduleListDropoff: PickupDropoff[] = [];
  termsAndCondition: TermsAndConditionsModel;

  selectedTermsAndCondition: string = '';
  documentTypeList: LeaseDocuments[] = [];
  selectedDocument: LeaseDocuments = null;
  selectedDocumentType: string = "";
  uploadedDocuments: DocumentModel[] = [];
  showUpload: boolean = false;
  showRemarks: boolean = false;
  remarks: string = '';
  isInternal: boolean;
  remarksList: LeaseRemarksList[] = [];

  pickUpScheduleList: PickupSchedule[] = [];
  dropoffScheduleList: DropoffSchedule[] = [];
  pickUpSchedule: PickupSchedule;
  dropoffSchedule: DropoffSchedule;
  pickupDisplayColumns: string[] = [];
  dropoffDisplayColumns: string[] = [];

  disableSave: boolean = false;
  loading: boolean = false;
  penaltyTypesOptions;
  savedEros = [];

  lease_quote_for_post = {};
  lease_quote_for_review = {};
  agreementPayload = [];
  quoteItemsPayload = [];
  quoteChargesPayload = [];

  @Input() requestDetails: RequestDetailModel;
  leaseDocDetails = new LeaseAgreementTncDocumentsClass();
  displayedColumns: string[] = ['original_filename', 'document_size', 'document_type', 'created_by'];
  @Output() editLR = new EventEmitter<any>();

  @ViewChild(InfoContentComponent) infoContentComponent: InfoContentComponent;
  @ViewChild(PickupDropoffScheduleLeaseComponent) pickupDropoffScheduleLeaseComponent: PickupDropoffScheduleLeaseComponent;

  agreementCurrency: string = '';
  agreementDays: number;
  updatedCurrency: string = null;
  base_url = environment.baseApiUrl;
  dd_leaseOptions: any;
  dd_leaseUse: BackendListModel<DomainCode>;
  pickupSchedulePayload: PickupSchedule[];
  dropoffSchedulePayload: DropoffSchedule[];
  pickupReviewSchedulePayload: PickupSchedule[];
  dropoffReviewSchedulePayload: DropoffSchedule[];
  containerSizeType: ContainerSizeType;

  modules = {};
  @ViewChild('editor', { static: false }) editor: QuillEditorComponent;

  scheduleList: LeaseQuoteModel;
  viewScheduleTable: boolean = false;

  consolidatedQuoteCharges: RequestQuotesChargesList[] = [];
  nonConsolidatedQuoteCharges: RequestQuotesChargesList[] = [];
  chargeMasterValidated: boolean = true;
  quoteChargeMasterValidated: boolean = true;
  chargeMasterPayload = [];
  default_currency: any;
  @Input() leaseRequestDetails: any | undefined;
  constructor(private domainService: DomainCodeApiService,
    public requestService: RequestApiService,
    private authService: AuthService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    public router: Router,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private cdRef: ChangeDetectorRef,
    public leaseQuoteService: LeaseQuoteTableService) {
    this.modules = {
      toolbar: false
    }
  }


  ngOnInit(): void {
    console.log("leaseRequestDetails", this.leaseRequestDetails)
    this.refreshComponent();
    this.route.queryParams.subscribe(params => {
      if ('id' in params || 'type' in params || 'rtype' in params) {
        this.requestId = params['id'];
        // this.type = params['type'];
        this.rType = params['rtype'];
      }
    });
    this.isCustomer = this.authService.isCustomer();
    this.earlyReturnOption = [
      {
        code: true,
        value: 'Yes'
      },
      {
        code: false,
        value: 'No'
      }
    ];
    this.getLeaseUse();
    if (!this.isCustomer) {
      this.leaseAgreementOptions(this.requestId);
      this.getPenaltyTypes();
    }
    this.getContainerCondition();
    this.getDocumentTypeList();
    this.getRequestQuoteCharges();
    // this.getRemarksList();
    this.refreshQuote.subscribe(item => {
      this.viewScheduleTable = false;
      console.log('refreshQuote item', item);
      if (item == null)
        return;
      if (item == 'review') {
        this.reviewQuote('review');
        return;
      }
      if (item == 'error') {
        this.leaseQuoteService.baseQuote.quote_items = [];
        for (let i = 0; i < this.requestService.selectedRequest.requirement.length; i++) {
          this.leaseQuoteService.baseQuote.quote_items[i] = new LeaseQuoteItemModel();
          this.leaseQuoteService.baseQuote.error.quote_items[i] = new LeaseQuoteItemError();
          this.leaseQuoteService.baseQuote.quote_items[i].saveFirstPayload(this.requestService.selectedRequest.requirement[i]);
          this.leaseQuoteService.baseQuote.quote_items[i].pol_list = this.requestService.selectedRequest.pols;
          this.leaseQuoteService.baseQuote.quote_items[i].pod_list = this.requestService.selectedRequest.pods;
          this.leaseQuoteService.baseQuote.pickup_schedules = [];
          this.leaseQuoteService.baseQuote.dropoff_schedules = [];
          this.scheduleList = null;
          this.viewScheduleTable = true;
          this.quoteList = this.leaseQuoteService.baseQuote.quote_items;
          this.quoteList.map(quote => {
            quote.per_diem_charge_currency = (quote.per_diem_charge_currency == null || quote.per_diem_charge_currency == '') ? this.requestDetails.lease_agreement.currency : quote.per_diem_charge_currency;
            quote.post_build_down_per_diem_charge_currency = (quote.post_build_down_per_diem_charge_currency == null || quote.post_build_down_per_diem_charge_currency == '') ? this.requestDetails.lease_agreement.currency : quote.post_build_down_per_diem_charge_currency;
            quote.drv_new_build_price_currency = (quote.drv_new_build_price_currency == null || quote.drv_new_build_price_currency == '') ? this.requestDetails.lease_agreement.currency : quote.drv_new_build_price_currency;
          });
        }
      } else {
        // this.baseQuote = new LeaseQuoteModel(item);
        this.leaseQuoteService.baseQuote = new LeaseQuoteModel(item);
        this.leaseQuoteService.termsAndCondition = this.leaseQuoteService.baseQuote.terms_and_condition_fk;
        this.leaseQuoteService.selectedTermsAndCondition = this.leaseQuoteService.baseQuote.terms_and_condition_text;
        this.leaseQuoteService.baseQuote.lease_agreement = new LeaseAgreement(item.lease_agreement);
        this.leaseQuoteService.baseQuote.error.lease_agreement = new LeaseAgreementError();
        for (let i = 0; i < item.quote_items.length; i++) {
          this.leaseQuoteService.baseQuote.quote_items[i] = new LeaseQuoteItemModel(item.quote_items[i]);
          this.leaseQuoteService.baseQuote.error.quote_items[i] = new LeaseQuoteItemError();
          if (this.leaseQuoteService.baseQuote.quote_items[i].ero.length != 0)
            this.leaseQuoteService.baseQuote.quote_items[i].is_ero_enabled = {
              code: true,
              value: 'Yes'
            };
          else
            this.leaseQuoteService.baseQuote.quote_items[i].is_ero_enabled = {
              code: false,
              value: 'No'
            };
        }

        this.quoteList = this.leaseQuoteService.baseQuote.quote_items;
        this.quoteList.map(quote => {
          quote.per_diem_charge_currency = (quote.per_diem_charge_currency == null || quote.per_diem_charge_currency == '') ? this.requestDetails.lease_agreement.currency : quote.per_diem_charge_currency;
          quote.post_build_down_per_diem_charge_currency = (quote.post_build_down_per_diem_charge_currency == null || quote.post_build_down_per_diem_charge_currency == '') ? this.requestDetails.lease_agreement.currency : quote.post_build_down_per_diem_charge_currency;
          quote.drv_new_build_price_currency = (quote.drv_new_build_price_currency == null || quote.drv_new_build_price_currency == '') ? this.requestDetails.lease_agreement.currency : quote.drv_new_build_price_currency;

          quote.ad_hoc_charges.map(charge => charge.error = new QuoteChargeMasterError());
        });

        if (this.leaseQuoteService.baseQuote.uploaded_documents.length != 0) {
          this.showUpload = true;
        }

        if (this.leaseQuoteService.baseQuote.pickup_schedules.length != 0) {
          this.leaseQuoteService.baseQuote.pickup_schedules.map(pickup => pickup.error = new PickupScheduleError());
          this.leaseQuoteService.baseQuote.dropoff_schedules.map(dropoff => dropoff.error = new DropoffScheduleError());
        }
        // console.log("this.quoteList check new", this.quoteList)

        if (this.leaseQuoteService.baseQuote.ad_hoc_charges.length != 0) {
          this.leaseQuoteService.baseQuote.ad_hoc_charges.map(charges => charges.error = new QuoteChargeMasterError());
        }

        console.log('item ------------------>', item);
        this.scheduleList = item;
        this.viewScheduleTable = true;

      }
      if (this.leaseRequestDetails.status.dev_name = 'received') {
        this.default_currency = this.leaseRequestDetails.requestor.company?.default_currency;
        // for (let i = 0; i < this.requestService.selectedRequest.requirement.length; i++) {
        //   this.leaseQuoteService.baseQuote.quote_items[i] = new LeaseQuoteItemModel();
        //   this.leaseQuoteService.baseQuote.quote_items[i]['per_diem_charge_currency'] = this.default_currency;
        //   this.leaseQuoteService.baseQuote.quote_items[i]['post_build_down_per_diem_charge_currency'] = this.default_currency;
        //   this.leaseQuoteService.baseQuote.quote_items[i]['drv_new_build_price_currency'] = this.default_currency;
        //   this.leaseQuoteService.baseQuote.quote_items[i]['drv_max_depreciation_price_currency'] = this.default_currency;
        //   this.leaseQuoteService.baseQuote.quote_items[i]['amount_currency'] = this.default_currency;

        // }
        this.quoteList = this.leaseQuoteService.baseQuote.quote_items;
        this.quoteList.map(quote => {
          quote['per_diem_charge_currency'] = this.default_currency;
          quote['post_build_down_per_diem_charge_currency'] = this.default_currency;
          quote['drv_new_build_price_currency'] = this.default_currency;
          quote['drv_max_depreciation_price_currency'] = this.default_currency;
          quote['amount_currency'] = this.default_currency;
        });
      }
      this.getTermsAndConditionMasterList();
      this.cdRef.detectChanges();
    });

    this.leaseDocDetails = new LeaseAgreementTncDocumentsClass();

    this.agreementCurrency = this.requestService.selectedRequest?.lease_agreement.currency;
  }

  refreshComponent() {
    this.leaseQuoteService.baseQuote = new LeaseQuoteModel();
    this.isCustomer = this.authService.isCustomer();
    this.getTermsAndConditionMasterList();
  }
  getContainerCondition() {
    this.domainService.getByGroup('ContainerCondition').subscribe({
      next: response => {
        this.containerConditionList = response;
      },
      error: error => {
        return error;
      }
    });
  }

  editQuote() {
    this.Editing = !this.Editing;
    this.edit.emit();
  }

  saveQuotation() {
    this.quoteChargeMasterValidated = true;
    this.disableSaveButton = true;
    this.lease_quote_for_post = [];
    const firstQuote = this.quoteList[0];
    this.quoteList.forEach(item => {
      item.container_deemed_lost_after_days = firstQuote.container_deemed_lost_after_days;
      item.notice_period_amendment_delivery_days = firstQuote.notice_period_amendment_delivery_days;
      item.notice_period_amendment_return_days = firstQuote.notice_period_amendment_return_days;
    })

    this.chargeMasterValidated = this.getQuoteChargeMasterPayload();

    if (this.leaseQuoteService.baseQuote.ad_hoc_charges.length != 0) {
      for (let i = 0; i < this.leaseQuoteService.baseQuote.ad_hoc_charges.length; i++) {
        for (let k = i + 1; k < this.leaseQuoteService.baseQuote.ad_hoc_charges.length; k++) {
          if (this.leaseQuoteService.baseQuote.ad_hoc_charges[i]?.quote_charge.id == this.leaseQuoteService.baseQuote.ad_hoc_charges[k]?.quote_charge.id) {
            this.openWarningDialog('Duplicate Request Quote Ad-hoc charge entries', '', 'Ok');
            return;
          }
        }
      }
    }

    if (!this.chargeMasterValidated) {
      this.disableSaveButton = false;
      this.openWarningDialog('Please select charge and enter all details', '', 'Ok');
      return;
    }

    this.getAgreementPayload();

    this.getQuoteSavePayload();

    let skipSave = false;

    this.quoteItemsPayload.map(quoteItems => {
      if (quoteItems.ad_hoc_charges.length != 0) {
        quoteItems.ad_hoc_charges.map(charge => {
          if (charge.quote_charge == null || charge.amount == null || charge.amount_currency == null) {
            this.quoteChargeMasterValidated = false;
          }
        })

        for (let i = 0; i < quoteItems.ad_hoc_charges.length; i++) {
          for (let k = i + 1; k < quoteItems.ad_hoc_charges.length; k++) {
            if (quoteItems.ad_hoc_charges[i]?.quote_charge.id == quoteItems.ad_hoc_charges[k]?.quoteItems_charge.id) {
              this.openWarningDialog('Duplicate Ad-hoc charge entries', '', 'Ok');
              this.disableSaveButton = false;
              skipSave = true;
              return;
            }
          }
        }
      } else {
        this.quoteChargeMasterValidated = true;
      }
    });

    if (skipSave) return;

    if (!this.quoteChargeMasterValidated) {
      this.disableSaveButton = false;
      this.openWarningDialog('Please select charge and enter all details', '', 'Ok');
      return;
    }

    this.getSchedulePayload();

    this.lease_quote_for_post = {
      quote_items: this.quoteItemsPayload,
      lease_agreement: this.agreementPayload[0],
      pickup_schedules: this.pickupSchedulePayload,
      dropoff_schedules: this.dropoffSchedulePayload,
      quote_valid_till: this.leaseQuoteService.baseQuote.quote_valid_till,
      remarks: this.leaseQuoteService.baseQuote.remarks,
      terms_and_condition_text: this.selectedTermsAndCondition,
      terms_and_condition_fk: this.termsAndCondition.id,
      request: this.requestId,
      uploaded_documents: this.leaseQuoteService.baseQuote.uploaded_documents ? this.leaseQuoteService.baseQuote.uploaded_documents.map(item => item.id) : [],
      ad_hoc_charges: this.chargeMasterPayload
    }
    console.log(this.lease_quote_for_post);

    this.requestService.postQuotations(this.lease_quote_for_post).subscribe({
      next: response => {
        this.snackBar.open('Quotations saved', 'Close', {
          verticalPosition: 'top',
          duration: 3000,
        });
        // console.log('postQuotations', response);
        this.disableSaveButton = false;
        window.location.reload();
        return response;
      },
      error: error => {
        console.log('error', error);
        // this.infoContentComponent.isEditable = true;
        // this.infoContentComponent.catchError(error);
        this.disableSaveButton = false;
        return this.catchError(error, this.pickupSchedulePayload, this.dropoffSchedulePayload);
      }
    });

    // this.leaseQuoteService.saveQuotation();
  }

  getQuoteChargeMasterPayload() {
    this.chargeMasterPayload = [];
    if (this.leaseQuoteService.baseQuote.ad_hoc_charges.length != 0) {
      this.leaseQuoteService.baseQuote.ad_hoc_charges.map(charge => {
        if (charge['quote_charge'] != null && charge['amount'] != null && charge['amount_currency'] != null) {
          this.chargeMasterPayload.push({
            quote_charge: charge['quote_charge'].id,
            amount: charge['amount'],
            amount_currency: charge['amount_currency']
          });
          this.chargeMasterValidated = true;
        } else {
          this.chargeMasterValidated = false;
        }
      })
    } else {
      this.chargeMasterValidated = true;
    }
    return this.chargeMasterValidated;
  }

  getQuoteSavePayload() {
    this.quoteItemsPayload = [];

    const adHocCharges = this.quoteList[0].ad_hoc_charges;
    for (let i = 1; i < this.quoteList.length; i++) {
      const currentAdHocCharges = this.quoteList[i].ad_hoc_charges;
      for (let j = 0; j < adHocCharges.length && j < currentAdHocCharges.length; j++) {
        currentAdHocCharges[j].quote_charge = adHocCharges[j].quote_charge;
      }
    }

    this.quoteList.map(quote => {
      this.quoteChargesPayload = [];
      quote.ero.map(ero => {
        ero.penalty_from = ero.penalty_from instanceof Object ? ero.penalty_from.value : ero.penalty_from;
      });

      if (quote.ad_hoc_charges.length != 0) {
        quote.ad_hoc_charges.map(charge => {
          this.quoteChargesPayload.push({
            quote_charge: charge['quote_charge'] != null ? charge['quote_charge'].id : null,
            amount: charge['amount'],
            amount_currency: charge['amount_currency']
          });
        })
      }

      this.quoteItemsPayload.push({
        requirement: quote.requirement,
        container_size_type: quote.container_size_type,
        per_diem_charge: quote.per_diem_charge,
        per_diem_charge_currency: quote.per_diem_charge_currency,
        leasing_period_days: quote.leasing_period_days,
        container_condition: quote.container_condition ? quote.container_condition.id : null,
        pol_list: quote.pol_list ? quote.pol_list.map((item) => item.id) : [],
        pod_list: quote.pod_list ? quote.pod_list.map((item) => item.id) : [],
        build_up_period_days: quote.build_up_period_days,
        build_down_period_days: quote.build_down_period_days,
        post_build_down_per_diem_charge: quote.post_build_down_per_diem_charge,
        minimum_rental_period_days: quote.minimum_rental_period_days,
        post_build_down_per_diem_charge_currency: quote.post_build_down_per_diem_charge_currency,
        container_deemed_lost_after_days: quote.container_deemed_lost_after_days,
        notice_period_amendment_delivery_days: quote.notice_period_amendment_delivery_days,
        notice_period_amendment_return_days: quote.notice_period_amendment_return_days,
        drv_new_build_price: quote.drv_new_build_price,
        drv_new_build_price_currency: quote.drv_new_build_price_currency,
        drv_depreciation_per_year: quote.drv_depreciation_per_year,
        drv_max_depreciation_percent: quote.drv_max_depreciation_percent,
        quantity: quote.quantity,
        is_ero_enabled: quote.is_ero_enabled.code == true ? true : false,
        ero: quote.is_ero_enabled.code == true ? quote.ero : [],
        drv_max_depreciation_price: quote.drv_max_depreciation_price,
        drv_max_depreciation_price_currency: quote.drv_max_depreciation_price_currency,
        drv_max_depreciation_unit: quote.drv_max_depreciation_unit,
        ad_hoc_charges: this.quoteChargesPayload
      })
    });
  }

  getAgreementPayload() {
    this.agreementPayload = [];
    var lease_purpose = null, lease_type = null, billing_cycle = null, billing_date = null;

    if (this.requestDetails.lease_agreement.lease_purpose != null) {
      if (this.requestDetails.lease_agreement.lease_purpose instanceof Object)
        lease_purpose = this.requestDetails.lease_agreement.lease_purpose.id;
      else
        lease_purpose = this.dd_leaseUse ? this.dd_leaseUse?.results.filter(item => item.dev_value == (this.requestDetails.lease_agreement.lease_purpose ? this.requestDetails.lease_agreement.lease_purpose.dev_value : null)).map(item => item.id)[0] : null;

    }
    if (this.requestDetails.lease_agreement.lease_type != null) {
      if (this.requestDetails.lease_agreement.lease_type instanceof Object)
        lease_type = this.requestDetails.lease_agreement.lease_type.value;
      else
        lease_type = this.dd_leaseOptions?.actions?.POST?.lease_type.choices.filter(item => item.display_name == this.requestDetails.lease_agreement.lease_type).map(item => item.value)[0];

    }
    if (this.requestDetails.lease_agreement.billing_cycle != null) {
      if (this.requestDetails.lease_agreement.billing_cycle instanceof Object)
        billing_cycle = this.requestDetails.lease_agreement.billing_cycle.value;
      else
        billing_cycle = this.dd_leaseOptions?.actions?.POST?.billing_cycle.choices.filter(item => item.display_name == this.requestDetails.lease_agreement.billing_cycle).map(item => item.value)[0];

    }
    if (this.requestDetails.lease_agreement.billing_date != null) {
      if (this.requestDetails.lease_agreement.billing_date instanceof Object)
        billing_date = this.requestDetails.lease_agreement.billing_date.value;
      else
        billing_date = this.dd_leaseOptions?.actions?.POST?.billing_date.choices.filter(item => item.display_name == this.requestDetails.lease_agreement.billing_date).map(item => item.value)[0];

    }

    this.agreementPayload.push({
      id: this.requestService.selectedRequest.lease_agreement.id,
      lease_purpose: lease_purpose,
      lease_type: lease_type,
      billing_cycle: billing_cycle,
      billing_date: billing_date,
      security_deposit_currency: this.requestDetails.lease_agreement.security_deposit_currency,
      security_deposit: this.requestDetails.lease_agreement.security_deposit,
      agreement_number: this.requestDetails.lease_agreement.agreement_number,
      agreement_starts_from: this.requestDetails.lease_agreement.agreement_starts_from,
      agreement_ends_on: this.requestDetails.lease_agreement.agreement_ends_on,
      currency: this.requestDetails.lease_agreement.currency,
      remarks: this.requestDetails.lease_agreement.remarks,
      lessor_company_name: this.requestDetails.lease_agreement.lessor_company_name,
      lessor_contact_person_name: this.requestDetails.lease_agreement.lessor_contact_person_name,
      lessor_contact_person_email: this.requestDetails.lease_agreement.lessor_contact_person_email,
      lessor_contact_person_phone: this.requestDetails.lease_agreement.lessor_contact_person_phone,
      lessee_company_name: this.requestDetails.lease_agreement.lessee_company_name,
      lessee_contact_person_name: this.requestDetails.lease_agreement.lessee_contact_person_name,
      lessee_contact_person_email: this.requestDetails.lease_agreement.lessee_contact_person_email,
      lessee_contact_person_phone: this.requestDetails.lease_agreement.lessee_contact_person_phone,
      lessor_company_address: this.requestDetails.lease_agreement.lessor_company_address,
      lessee_company_address: this.requestDetails.lease_agreement.lessee_company_address,
      request: this.requestId
    });
  }

  getSchedulePayload() {
    this.pickupSchedulePayload = [];
    this.dropoffSchedulePayload = [];

    this.scheduleListP = this.pickupDropoffScheduleLeaseComponent.pickupDataSource;
    this.scheduleListD = this.pickupDropoffScheduleLeaseComponent.dropoffDataSource;

    // console.log('getSchedulePayload', this.scheduleListP);
    // console.log('getSchedulePayload', this.scheduleListD);

    this.scheduleListP.map(pickup => {
      pickup.client_id = pickup.id;
      if (pickup.port instanceof Object)
        pickup.port = pickup.port.id;
      if (pickup.requirement instanceof Object)
        pickup.requirement = pickup.requirement.id;
      this.pickupSchedulePayload.push(pickup);
    });

    this.scheduleListD.map(dropoff => {
      dropoff.client_id = dropoff.id;
      if (dropoff.port instanceof Object)
        dropoff.port = dropoff.port.id;
      if (dropoff.requirement instanceof Object)
        dropoff.requirement = dropoff.requirement.id;
      this.dropoffSchedulePayload.push(dropoff);
    });
  }

  leaseAgreementOptions(reqId) {
    this.requestService.optionsLeaseAgreement(this.requestDetails.id).subscribe(response => {
      this.dd_leaseOptions = response;
    })
  }

  getLeaseUse() {
    this.domainService.getByGroup('ContainerPurpose').subscribe(response => {
      this.dd_leaseUse = response;
    })
  }

  reviewQuote(type: string) {
    if (this.leaseQuoteService.baseQuote.ad_hoc_charges.length != 0) {
      this.leaseQuoteService.baseQuote.ad_hoc_charges.map((charge: any) => {
        console.log(charge.quote_charge, charge.amount, charge.amount_currency);
        if (charge.quote_charge == null || charge.amount == null || charge.amount_currency == null) {
          this.quoteChargeMasterValidated = false;
        } else {
          this.quoteChargeMasterValidated = true;
        }
      })

      for (let i = 0; i < this.leaseQuoteService.baseQuote.ad_hoc_charges.length; i++) {
        for (let k = i + 1; k < this.leaseQuoteService.baseQuote.ad_hoc_charges.length; k++) {
          if (this.leaseQuoteService.baseQuote.ad_hoc_charges[i]?.quote_charge.id == this.leaseQuoteService.baseQuote.ad_hoc_charges[k]?.quote_charge.id) {
            this.openWarningDialog('Duplicate Request Quote Ad-hoc charge entries', '', 'Ok');
            return;
          }
        }
      }
    }

    if (!this.quoteChargeMasterValidated) {
      this.disableSaveButton = false;
      this.openWarningDialog('Please select charge and enter all details', '', 'Ok');
      return;
    }

    const firstQuote = this.quoteList[0];
    this.quoteList.forEach(item => {
      item.container_deemed_lost_after_days = firstQuote.container_deemed_lost_after_days;
      item.notice_period_amendment_delivery_days = firstQuote.notice_period_amendment_delivery_days;
      item.notice_period_amendment_return_days = firstQuote.notice_period_amendment_return_days;
    })

    this.getReviewAgreement();
    this.getReviewQuote();

    let skipReview = false;

    this.quoteItemsPayload.map(quoteItems => {
      if (quoteItems.ad_hoc_charges.length != 0) {
        quoteItems.ad_hoc_charges.map(charge => {
          if (charge.quote_charge == null || charge.amount == null || charge.amount_currency == null) {
            this.quoteChargeMasterValidated = false;
          }
        });

        for (let i = 0; i < quoteItems.ad_hoc_charges.length; i++) {
          for (let k = i + 1; k < quoteItems.ad_hoc_charges.length; k++) {
            if (quoteItems.ad_hoc_charges[i]?.quote_charge.id == quoteItems.ad_hoc_charges[k]?.quoteItems_charge.id) {
              this.openWarningDialog('Duplicate Ad-hoc charge entries', '', 'Ok');
              this.disableSaveButton = false;
              skipReview = true;
              return;
            }
          }
        }
      } else {
        this.quoteChargeMasterValidated = true;
      }
    });

    if (skipReview) return;

    if (!this.quoteChargeMasterValidated) {
      this.disableSaveButton = false;
      this.openWarningDialog('Please select charge and enter all details', '', 'Ok');
      return;
    }
    this.getReviewSchedulePayload();

    this.lease_quote_for_review = {
      ad_hoc_charges: this.leaseQuoteService.baseQuote.ad_hoc_charges,
      quote_items: this.quoteItemsPayload,
      lease_agreement: this.agreementPayload[0],
      pickup_schedules: this.pickupSchedulePayload,
      dropoff_schedules: this.dropoffSchedulePayload,
      quote_valid_till: this.leaseQuoteService.baseQuote.quote_valid_till,
      remarks: this.leaseQuoteService.baseQuote.remarks,
      terms_and_condition_text: this.selectedTermsAndCondition,
      terms_and_condition_fk: this.termsAndCondition.id,
      request: this.requestId,
      uploaded_documents: this.leaseQuoteService.baseQuote.uploaded_documents
    }
    this.leaseQuoteService.type = type;
    this.review.emit(this.lease_quote_for_review);
  }

  getReviewQuote() {
    this.quoteItemsPayload = [];
    const adHocCharges = this.quoteList[0].ad_hoc_charges;
    for (let i = 1; i < this.quoteList.length; i++) {
      const currentAdHocCharges = this.quoteList[i].ad_hoc_charges;
      for (let j = 0; j < adHocCharges.length && j < currentAdHocCharges.length; j++) {
        currentAdHocCharges[j].quote_charge = adHocCharges[j].quote_charge;
      }
    }

    this.quoteList.map(quote => {
      quote.ero.map(ero => {
        ero.penalty_from = ero.penalty_from instanceof Object ? ero.penalty_from.value : ero.penalty_from;
      });

      this.quoteItemsPayload.push({
        ad_hoc_charges: quote.ad_hoc_charges,
        requirement: quote.requirement,
        container_size_type: quote.container_size_type,
        per_diem_charge: quote.per_diem_charge,
        per_diem_charge_currency: quote.per_diem_charge_currency,
        leasing_period_days: quote.leasing_period_days,
        container_condition: quote.container_condition,
        pol_list: quote.pol_list ? quote.pol_list.map((item) => item) : [],
        pod_list: quote.pod_list ? quote.pod_list.map((item) => item) : [],
        build_up_period_days: quote.build_up_period_days,
        build_down_period_days: quote.build_down_period_days,
        minimum_rental_period_days: quote.minimum_rental_period_days,
        post_build_down_per_diem_charge: quote.post_build_down_per_diem_charge,
        post_build_down_per_diem_charge_currency: quote.post_build_down_per_diem_charge_currency,
        container_deemed_lost_after_days: quote.container_deemed_lost_after_days,
        notice_period_amendment_delivery_days: quote.notice_period_amendment_delivery_days,
        notice_period_amendment_return_days: quote.notice_period_amendment_return_days,
        drv_new_build_price: quote.drv_new_build_price,
        drv_new_build_price_currency: quote.drv_new_build_price_currency,
        drv_depreciation_per_year: quote.drv_depreciation_per_year,
        drv_max_depreciation_percent: quote.drv_max_depreciation_percent,
        drv_max_depreciation_unit: quote.drv_max_depreciation_unit,
        drv_max_depreciation_price: quote.drv_max_depreciation_price,
        drv_max_depreciation_price_currency: quote.drv_max_depreciation_price_currency,
        quantity: quote.quantity,
        is_ero_enabled: quote.is_ero_enabled.code == true ? true : false,
        ero: quote.is_ero_enabled.code == true ? quote.ero : []
      })
    });
  }

  getReviewAgreement() {
    this.agreementPayload = [];
    var lease_type = null, billing_cycle = null, billing_date = null;

    if (this.requestDetails.lease_agreement.lease_type != null) {
      if (this.requestDetails.lease_agreement.lease_type instanceof Object)
        lease_type = this.requestDetails.lease_agreement.lease_type;
      else
        lease_type = {
          display_name: this.dd_leaseOptions?.actions?.POST?.lease_type.choices.filter(item => item.display_name == this.requestDetails.lease_agreement.lease_type).map(item => item.display_name)[0],
          value: this.dd_leaseOptions?.actions?.POST?.lease_type.choices.filter(item => item.display_name == this.requestDetails.lease_agreement.lease_type).map(item => item.value)[0],
        }
    }
    if (this.requestDetails.lease_agreement.billing_cycle != null) {
      if (this.requestDetails.lease_agreement.billing_cycle instanceof Object)
        billing_cycle = this.requestDetails.lease_agreement.billing_cycle;
      else
        billing_cycle = {
          display_name: this.dd_leaseOptions?.actions?.POST?.billing_cycle.choices.filter(item => item.display_name == this.requestDetails.lease_agreement.billing_cycle).map(item => item.display_name)[0],
          value: this.dd_leaseOptions?.actions?.POST?.billing_cycle.choices.filter(item => item.display_name == this.requestDetails.lease_agreement.billing_cycle).map(item => item.value)[0]
        }
    }
    if (this.requestDetails.lease_agreement.billing_date != null) {
      if (this.requestDetails.lease_agreement.billing_date instanceof Object)
        billing_date = this.requestDetails.lease_agreement.billing_date;
      else
        billing_date = {
          display_name: this.dd_leaseOptions?.actions?.POST?.billing_date.choices.filter(item => item.display_name == this.requestDetails.lease_agreement.billing_date).map(item => item.display_name)[0],
          value: this.dd_leaseOptions?.actions?.POST?.billing_date.choices.filter(item => item.display_name == this.requestDetails.lease_agreement.billing_date).map(item => item.value)[0]
        }
    }

    this.agreementPayload.push({
      id: this.requestService.selectedRequest.lease_agreement.id,
      lease_purpose: this.requestDetails.lease_agreement.lease_purpose,
      lease_type: lease_type,
      billing_cycle: billing_cycle,
      billing_date: billing_date,
      security_deposit_currency: this.requestDetails.lease_agreement.security_deposit_currency,
      security_deposit: this.requestDetails.lease_agreement.security_deposit,
      agreement_number: this.requestDetails.lease_agreement.agreement_number,
      agreement_starts_from: this.requestDetails.lease_agreement.agreement_starts_from,
      agreement_ends_on: this.requestDetails.lease_agreement.agreement_ends_on,
      currency: this.requestDetails.lease_agreement.currency,
      remarks: this.requestDetails.lease_agreement.remarks,
      lessor_company_name: this.requestDetails.lease_agreement.lessor_company_name,
      lessor_contact_person_name: this.requestDetails.lease_agreement.lessor_contact_person_name,
      lessor_contact_person_email: this.requestDetails.lease_agreement.lessor_contact_person_email,
      lessor_contact_person_phone: this.requestDetails.lease_agreement.lessor_contact_person_phone,
      lessee_company_name: this.requestDetails.lease_agreement.lessee_company_name,
      lessee_contact_person_name: this.requestDetails.lease_agreement.lessee_contact_person_name,
      lessee_contact_person_email: this.requestDetails.lease_agreement.lessee_contact_person_email,
      lessee_contact_person_phone: this.requestDetails.lease_agreement.lessee_contact_person_phone,
      lessor_company_address: this.requestDetails.lease_agreement.lessor_company_address,
      lessee_company_address: this.requestDetails.lease_agreement.lessee_company_address,
      request: this.requestId
    });
  }

  getReviewSchedulePayload() {
    this.pickupSchedulePayload = [];
    this.dropoffSchedulePayload = [];

    this.scheduleListP = this.pickupDropoffScheduleLeaseComponent.pickupDataSource;
    this.scheduleListD = this.pickupDropoffScheduleLeaseComponent.dropoffDataSource;

    this.scheduleListP.map(pickup => {
      if (pickup.port instanceof Object)
        pickup.port = pickup.port;
      if (pickup.requirement instanceof Object)
        pickup.requirement = pickup.requirement;
      this.pickupSchedulePayload.push(pickup);
    });

    this.scheduleListD.map(dropoff => {
      if (dropoff.port instanceof Object)
        dropoff.port = dropoff.port;
      if (dropoff.requirement instanceof Object)
        dropoff.requirement = dropoff.requirement;
      this.dropoffSchedulePayload.push(dropoff);
    });

  }


  catchError(error, pickupPayload?, dropoffpayload?) {
    if (error.status >= 500) {
      this.snackBar.open('Something went wrong!! Please try again after sometime.', 'Close', {
        verticalPosition: 'top',
        duration: 5000,
      });
      return error;
    } else if (error.status > 399 && error.status < 500) {
      this.leaseQuoteService.baseQuote.patchErrors(error.error);
      var err = error.error;
      if (err.pickup_schedules) {
        if (pickupPayload.length != 0) {
          const dataWithErrors = pickupPayload.map((row) => {
            const errorKey = row.client_id;
            const error =
              (err.pickup_schedules[errorKey]) || [];
            return {
              ...row,
              error,
            };
          });

          console.log(this.requestService.selectedRequest.requirement);

          this.pickupDropoffScheduleLeaseComponent.pickupDataSource.map(item => {
            dataWithErrors.map(data => {
              if (data.client_id == item.client_id) {
                item.error = data.error
              }
            })
          });

        }
      }
      this.pickupDropoffScheduleLeaseComponent.pickupDataSource.map(item => {
        item.requirement = this.requestService.selectedRequest.requirement.filter(req => req.id == item.requirement)[0];
        this.quoteList.map(quote => {
          if (quote.requirement == item.requirement.id) {
            quote.pol_list.map(pol => {
              if (pol.id == item.port)
                item.port = pol;
            })
          }
        })
      });

      if (err.dropoff_schedules) {
        if (dropoffpayload.length != 0) {
          const dataWithErrors = dropoffpayload.map((row) => {
            const errorKey = row.client_id;
            const error =
              (err.dropoff_schedules[errorKey]) || [];
            return {
              ...row,
              error,
            };
          });

          this.pickupDropoffScheduleLeaseComponent.dropoffDataSource.map(item => {
            dataWithErrors.map(data => {
              if (data.client_id == item.client_id)
                item.error = data.error
            })
          });

        }
      }
      this.pickupDropoffScheduleLeaseComponent.dropoffDataSource.map(item => {
        item.requirement = this.requestService.selectedRequest.requirement.filter(req => req.id == item.requirement)[0];
        this.quoteList.map(quote => {
          if (quote.requirement == item.requirement.id) {
            quote.pod_list.map(pod => {
              if (pod.id == item.port)
                item.port = pod;
            })
          }
        })
      });
      return error;
    }
  }

  editReview() {
    this.isEditable = true;
  }
  editRequest(data) {
    this.editLR.emit(data);
  }

  toogleReturnOption(event, quote) {
    this.agreementDays = quote.leasing_period_days;
    if (event != null) {
      if (event.code == true) {
        const dialogData = {
          quote: quote,
          penaltyTypesOptions: this.penaltyTypesOptions,
          type: 'a',
          agreementCurrency: this.agreementCurrency,
          agreementDays: this.agreementDays
        };
        const dialogRef = this.dialog.open(EroAddUpdateComponent, {
          // width: '50%',
          disableClose: true,
          data: dialogData
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {

          } else {

          }
        });

        dialogRef.componentInstance.savedEros.subscribe((data: any) => {

        });

        dialogRef.componentInstance.closeEroDialog.subscribe((data: any) => {
          if (quote.ero?.length == 0)
            quote.is_ero_enabled = {
              code: false,
              value: 'No'
            };
        });
      }
    }
  }

  viewEroDetails(quote) {
    this.agreementDays = quote.leasing_period_days;
    const dialogData = {
      quote: quote,
      penaltyTypesOptions: this.penaltyTypesOptions,
      type: 'u',
      agreementCurrency: this.agreementCurrency,
      agreementDays: this.agreementDays
    };
    const dialogRef = this.dialog.open(EroAddUpdateComponent, {
      // width: '50%',
      disableClose: true,
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {

      } else {

      }
    });

    dialogRef.componentInstance.savedEros.subscribe((data: any) => {

    });

    dialogRef.componentInstance.closeEroDialog.subscribe((data: any) => {
      if (quote.ero?.length == 0)
        quote.is_ero_enabled = {
          code: false,
          value: 'No'
        };
    });
  }

  getPenaltyTypes() {
    this.requestService.getPenaltyTypes(this.requestId).subscribe(response => {
      this.penaltyTypesOptions = response;
    });
  }

  getTermsAndConditionMasterList() {
    this.requestService.getTermsAndConditionsListLease(this.requestService.selectedRequest).subscribe({
      next: response => {
        this.termsConditionList = response.results;
        if (this.termsConditionList.length != 0) {
          if (this.leaseQuoteService.baseQuote.terms_and_condition_fk != null) {
            this.termsAndCondition = {
              id: this.termsConditionList.filter(item => item.id == this.leaseQuoteService.baseQuote.terms_and_condition_fk)[0].id,
              name: this.termsConditionList.filter(item => item.id == this.leaseQuoteService.baseQuote.terms_and_condition_fk)[0].name
            };
            this.selectedTermsAndCondition = this.leaseQuoteService.baseQuote.terms_and_condition_text;
          } else {
            this.termsAndCondition = {
              id: this.termsConditionList[0].id,
              name: this.termsConditionList[0].name
            };
            this.selectedTermsAndCondition = this.termsConditionList[0].terms_condition;
          }
        }
        return response;
      },
      error: error => {
        // console.log(error)
        return error;
      }
    })
  }

  showSelectedTermsAndCondition() {
    if (this.termsConditionList.length != 0) {
      this.termsConditionList.map(item => {
        if (item.id == this.termsAndCondition) {
          this.termsAndCondition = {
            id: item.id,
            name: item.name
          };
          this.selectedTermsAndCondition = item.terms_condition;
        }
      })
    }
  }

  getDocumentTypeList() {
    this.requestService.getDocumentTypeList('lease_quote').subscribe(res => {
      this.documentTypeList = res.results;
    })
  }

  // getRemarksList() {
  //   this.requestService.getRemarksList(this.requestId).subscribe(res => {
  //     this.remarksList = res.results;
  //   })
  // }

  showDocumentUpload(event) {
    this.selectedDocument = event;
    if (this.selectedDocument != null) {
      this.selectedDocumentType = this.selectedDocument.dev_name;
      this.showUpload = true;
    } else {
      this.showUpload = false;
    }
  }

  addRemarks() {
    this.showRemarks = true;
  }

  // addNewRemarks() {
  //   if (this.remarks.length != 0) {
  //     this.requestService.postRequestRemarks(this.requestId, this.remarks, this.isInternal).subscribe(res => {
  //       this.remarksList = [];
  //       this.getRemarksList();
  //     })
  //     this.showRemarks = false;
  //   } else {
  //     window.alert('Please enter remarks')
  //   }
  // }

  cancelRemarksAddition() {
    this.remarks = '';
    this.showRemarks = false;
  }

  // getRemarks(event) {
  //   this.remarks = event.remarks;
  //   this.isInternal = event.is_internal;
  // }

  keysToTransform = [
    'lease_purpose',
  ];
  keysToTransform1 = [
    'terms_and_condition_fk'
  ]

  readableFileSize(size) {
    var units = ['B', 'KB', 'MB'];
    var i = 0;
    while (size >= 1024) {
      size /= 1024;
      ++i;
    }
    return size?.toFixed(2) + ' ' + units[i];
  }

  editPickupSchedule(data) {
    setTimeout(() => {
      this.editPickup.emit(data);
    }, 300);
  }

  editDropoffSchedule(data) {
    setTimeout(() => {
      this.editDropoff.emit(data);
    }, 300);
  }

  downloadQuote(quote) {
    window.open(`${this.downloadUrl}request_quotes/pdf/lease/${quote.id}/`, '_blank');
  }

  setLeaseDuration(event) {
    if (this.requestDetails?.lease_agreement.agreement_ends_on !== null && this.requestDetails?.lease_agreement.agreement_starts_from != null) {
      let end_date = new Date(this.requestDetails?.lease_agreement.agreement_starts_from);
      let leasingPeriodDays = null;
      leasingPeriodDays = this.leaseQuoteService.baseQuote?.quote_items.reduce((max, item) => (item.leasing_period_days > max ? item.leasing_period_days : max), this.leaseQuoteService.baseQuote?.quote_items[0].leasing_period_days);
      end_date.setDate(end_date.getDate() + leasingPeriodDays);
      this.requestDetails.lease_agreement.agreement_ends_on = end_date;
    }
  }

  cancelQuoteEditing() {
    this.updateRequest.emit();
  }
  selectChoice(event, index) {
    this.leaseQuoteService.baseQuote.quote_items[index].drv_max_depreciation_unit = event;
  }

  getRequestQuoteCharges() {
    this.requestService.getRequestQuoteCharges(this.rType).subscribe(res => {
      if (res.length != 0) {
        console.log('getRequestQuoteCharges', res);
        this.consolidatedQuoteCharges = res.filter(charge => charge.is_consolidated_charge == true);
        this.nonConsolidatedQuoteCharges = res.filter(charge => charge.is_consolidated_charge == false);
      }
      console.log('this.consolidatedQuoteCharges', this.consolidatedQuoteCharges);
      console.log('this.nonConsolidatedQuoteCharges', this.nonConsolidatedQuoteCharges);
    })
  }

  addCharge() {
    this.leaseQuoteService.baseQuote.ad_hoc_charges.push(new QuoteChargeMaster())
  }

  removeCharge(idx) {
    this.leaseQuoteService.baseQuote.ad_hoc_charges.splice(idx, 1);
  }

  addQuoteItemCharge(quoteList) {
    quoteList.map(quote => {
      if (quote.ad_hoc_charges == undefined)
        quote.ad_hoc_charges = [];
      quote.ad_hoc_charges.push(new QuoteChargeMaster());
    })
  }

  removeQuoteItemCharge(quoteList, idx) {
    quoteList.map(quote => {
      quote.ad_hoc_charges.splice(idx, 1);
    })
  }

  openWarningDialog(label: string, description, action1: string, action2?: string, action3: string = null) {
    const dialogRef = this.dialog.open(WarningBoxComponent, {
      panelClass: 'dialog-container-custom',
      disableClose: true,
      data: { subTitle: label, parent: this, description: description, label1: action1, label2: action2, label3: action3 }
    });

    dialogRef.afterClosed().subscribe(item => {
      if (item) {
      }
    })
  }

  setCharge(event, idx) {
    console.log(event.ad_hoc_charges, idx);

    // for(let i = 1; i < this.quoteList.length; i++) {

    // }


    // this.quoteList.map(quote => {
    //   quote.ad_hoc_charges.forEach((charge, index) => {
    //     console.log(charge, index);
    //     if(index != 0) {
    //       charge.quote_charge = charge.quote_charge
    //     }
    //   })
    // })
  }
}
